module.exports = __webpack_public_path__ + "static/assets/a510e2c02febcade2ecc23aa5a96cbd9.png";